var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLoud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 1.65246C19.5 1.38308 19.2084 1.21468 18.9751 1.3493L7.8 7.79647V15.0694L18.9585 22.3654C19.1912 22.5176 19.5 22.3505 19.5 22.0724V1.65246ZM6.19004 16.0711H3.56856L5.87754 22.6164C5.92692 22.7564 6.05919 22.85 6.20761 22.85H8.58142L6.19004 16.0711ZM2.17507 16.0286L4.65159 23.0489C4.88435 23.7087 5.50794 24.15 6.20761 24.15H9.07603C9.73142 24.15 10.1899 23.502 9.97192 22.884L7.7521 16.5913L18.247 23.4534C19.3445 24.171 20.8 23.3836 20.8 22.0724V15.4483C22.6848 15.2369 24.1499 13.6378 24.1499 11.6965C24.1499 9.75527 22.6848 8.1562 20.8 7.94477V1.65246C20.8 0.382525 19.4255 -0.411362 18.3255 0.223254L6.97594 6.77105H2.65C1.18645 6.77105 0 7.9575 0 9.42105V13.4211C0 14.7225 0.93815 15.8048 2.17507 16.0286ZM23.0712 11.6965C23.0712 13.0411 22.0872 14.1559 20.8 14.3599V9.03315C22.0872 9.2372 23.0712 10.352 23.0712 11.6965ZM2.65 14.7711H6.5V8.07105H2.65C1.90442 8.07105 1.3 8.67547 1.3 9.42105V13.4211C1.3 14.1666 1.90442 14.771 2.65 14.7711ZM4 13C4.55228 13 5 12.5523 5 12C5 11.4477 4.55228 11 4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13Z",
    fill: "#4485F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoud);
export default __webpack_public_path__ + "static/media/icon-loud.121a9d6b5eaba0ee88aeb5a850383f0e.svg";
export { ForwardRef as ReactComponent };